import { render, staticRenderFns } from "./ShoplazzaAuthorize.vue?vue&type=template&id=0edb33ac&scoped=true"
import script from "./ShoplazzaAuthorize.vue?vue&type=script&lang=js"
export * from "./ShoplazzaAuthorize.vue?vue&type=script&lang=js"
import style0 from "./ShoplazzaAuthorize.vue?vue&type=style&index=0&id=0edb33ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb33ac",
  null
  
)

export default component.exports